import { request } from "../util/Request";

export async function getTaskStatus() {
    const response = await request("/api/TaskStatus/GetTaskStatus");
    console.log(response);
    return await response.json();
  }